import { render, staticRenderFns } from "./inmueble-propietarios.vue?vue&type=template&id=55eb3988&"
import script from "./inmueble-propietarios.vue?vue&type=script&lang=js&"
export * from "./inmueble-propietarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports